<template>
    <div>
        <div class="row justify-center">
            <q-select
                    path="phone_prefix"
                    auto-select
                    v-model="phone_prefix"
                    :float-label="$T('phone prefix')"
                    :options="phonePrefixes"
                    class="col-12 col-md-3"
                    style="margin-right: 20px;"
            >
            </q-select>
            <q-input
                    path="phone"
                    v-model="phone"
                    :label="$T('cell phone')"
                    :float-label="$T('cell phone')"
                    class="col-12 col-md-3"
                    style="margin-right: 20px;"
            >
            </q-input>
        </div>
        <div class="row justify-center">
            <q-input
                    path="dni"
                    v-model="dni"
                    :label="$T('dni/nie')"
                    :float-label="$T('dni/nie')"
                    class="col-12 col-md-3"
                    style="margin-right: 20px;"
            >
            </q-input>

            <q-input
                    path="email"
                    v-model="email"
                    :label="$T('email')"
                    :float-label="$T('email')"
                    class="col-12 col-md-3"
                    style="margin-right: 20px;"
            >
            </q-input>
        </div>

        <div class="row justify-center">
            <v-button
                    outline
                    :loading="loading"
                    :label="$T('Validate')"
                    @click.native.prevent="validate"
                    icon="save"
                    color="highlight"
                    class="no-shadow uppercase q-btn-iqos"
                    style="margin-top:20px"
            >
            </v-button>
        </div>
    </div>
</template>


<script>
    import phonePrefixes from "../../helpers/phonePrefix"
    import VButton from "../../components/form/VButton"
    import axios from "axios"
    import {QDialog, QCard, QCardActions} from "quasar-framework"
    import {EventBus} from '../../plugins/event-bus'

    export default {
        name: "consumerEligibility",
        components: {VButton, QDialog, QCard, QCardActions},
        mixins: [phonePrefixes],

        data() {
            return {
                codeHasError: false,
                numberPattern: /\d+/g,
                loading: false,
                show_dialog: false,
                dni: "",
                phone_prefix: "0034",
                phone: "",
                email: "",
                token: "",
            };
        },
        methods: {
            notify(message, detail, actions = [], type = 'positive') {
                this.$q.notify({
                    type,
                    position: 'bottom-right',
                    message,
                    detail,
                    timeout: 5000,
                    actions
                })
            },
            validate() {
                this.loading = true;
                axios.get(`${config.appUrl}/api/v1/lending-point/consumer-eligibility`, {
                    params:
                        {
                            dni: this.dni,
                            phone_prefix: this.phone_prefix,
                            phone: this.phone,
                            email: this.email
                        }
                })
                    .then(response => {
                        if (response.data.status == true) {
                            EventBus.$emit('isEligible', this.phone, this.phone_prefix, this.dni, this.email)
                        }
                        else {
                            this.notify(this.$T('error'), response.data.message, [], 'negative')
                        }
                        this.loading = false;
                    })
                    .catch(response => {
                        console.log(response)
                    })
            }
        },
        computed: {

        },
        watch: {
            dni(newValue) {
                if (newValue && newValue.includes(' ')) {
                    this.dni = newValue.replace(/\s+/g, '');
                }
            },
            phone(newValue) {
                if (newValue && newValue.includes(' ')) {
                    const matches = newValue.match(this.numberPattern);
                    this.phone = matches ? matches.join('') : '';
                }
            },
            email(newValue) {
                if (newValue && newValue.includes(' ')) {
                    this.email = newValue.replace(/\s+/g, '');
                }
            }
        }
    };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// resources/assets/js/pages/lending-point/consumerEligibility.vue